import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { cn } from '../lib/cn';

/**
 * The × in the corner of dialogs and popovers (clicking beside them also closes
 * them, but that is not obvious). Use inside a Radix `Close` with `asChild`.
 */
export const CloseButton = forwardRef<HTMLButtonElement, ComponentPropsWithoutRef<'button'>>(
  function CloseButton({ className, ...props }, ref) {
    const { t } = useTranslation();
    return (
      <button
        ref={ref}
        type="button"
        aria-label={t('app.dismiss')}
        title={t('app.dismiss')}
        className={cn(
          'grid size-8 shrink-0 place-items-center rounded-full text-fg-muted hover:bg-bg-hover hover:text-fg',
          className,
        )}
        {...props}
      >
        <X className="size-4" />
      </button>
    );
  },
);
